import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllRoomNumberWithIDRequest,
  getAllRoomTypeWithIDRequest,
} from "../Redux/Actions";
import { FETCH_ROOM_REQUEST } from "../Utils/Constant";
import { toast } from "react-toastify";
import { hasEditAccess } from "./CheckAccess";

const RoomReassignmentModal = ({ isOpen, onClose, guest, onReassign }) => {
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const [FullRoomsData, setFullRoomData] = useState([]);
  const [reassignments, setReassignments] = useState([]);

  const { rooms } = useSelector((state) => state.frontdesk);

   const [permissions, setPermissions] = useState([]);
  
    const existingPermissions = localStorage.getItem("checkPermission");
  
    useEffect(() => {
      if (existingPermissions != undefined) {
        const parsedData = JSON.parse(existingPermissions);
        setPermissions(parsedData);
      }
    }, [existingPermissions]);
    
  useEffect(() => {
    if (isOpen) {
      dispatch(getAllRoomNumberWithIDRequest());
      dispatch(getAllRoomTypeWithIDRequest());
      setReason("");
      setNotes("");
    }
  }, [isOpen, dispatch]);

  useEffect(() => {
    let dates = {};
    if (guest?.checkIn && guest?.checkOut) {
      let start_date = new Date(guest.checkIn).toISOString();
      let end_date = new Date(guest.checkOut).toISOString();
      dates = { start_date, end_date };
    }
    dispatch({ type: FETCH_ROOM_REQUEST, payload: { ...dates } });
  }, [guest]);

  useEffect(() => {
    setFullRoomData(rooms?.data || []);
  }, [rooms]);
  useEffect(() => {
    if (guest?.rooms?.length) {
      const initial = {};
      guest.rooms.forEach((room) => {
        initial[room.id] = {
          selectedRoomType: "",
          selectedRoomNumber: "",
        };
      });
      setReassignments(initial);
    }
  }, [guest]);

  const getUniqueRoomTypes = () => {
    const types = FullRoomsData.map((room) => ({
      room_type: room.room_type,
      id: room.id,
    }));
    return [...new Set(types)];
  };

  const getRoomNumbersForType = (roomType) => {
    const roomData = FullRoomsData.find((room) => room.room_type === roomType);
    return roomData ? roomData.room : [];
  };

  const handleRoomTypeChange = (roomId, room_type_id, type) => {
    setReassignments((prev) => ({
      ...prev,
      [roomId]: {
        selectedRoomType: type,
        room_type_id: room_type_id,
        selectedRoomNumber: "",
      },
    }));
  };

  const handleRoomNumberChange = (roomId, number) => {
    setReassignments((prev) => ({
      ...prev,
      [roomId]: { ...prev[roomId], selectedRoomNumber: number },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const entries = Object.entries(reassignments).filter(
      ([, val]) => val.selectedRoomNumber
    );
    if (entries.length === 0 || !reason) {
      toast.error("Please select room(s) and reason");
      return;
    }
    onReassign(guest.id, reassignments, reason, notes);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              <i className="bi bi-arrow-repeat me-2"></i>Room Reassignment
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            {guest && (
              <>
                <div className="card border-info mb-3">
                  <div className="card-header bg-info text-white">
                    <h6 className="mb-0">Guest Information</h6>
                  </div>
                  <div className="card-body">
                    <p>
                      <strong>Name:</strong> {guest?.name}
                    </p>
                    <p>
                      <strong>Email:</strong> {guest?.email}
                    </p>
                    <p>
                      <strong>Current Room(s):</strong>{" "}
                      {guest?.rooms?.map((r) => r?.room_number).join(", ")}
                    </p>
                    <p>
                      <strong>Stay:</strong> {guest?.checkIn?.split(".")[0]} to{" "}
                      {guest?.checkOut?.split(".")[0]}
                    </p>
                  </div>
                </div>

                {guest.rooms?.map((room) => (
                  <div key={room.id} className="card border-warning mb-3">
                    <div className="card-header bg-warning text-dark">
                      <strong>Room {room?.room_number}</strong>
                    </div>
                    <div className="card-body row">
                      <div className="col-md-4">
                        <p>
                          <strong>Type:</strong> {room?.room?.room_type}
                        </p>
                        <p>
                          <strong>Floor:</strong> {room?.floor_number}
                        </p>
                        <p>
                          <strong>Capacity:</strong> {room?.room?.capacity}
                        </p>
                        <p>
                          <strong>Status:</strong>
                          <span
                            className={`badge ms-2 ${
                              room?.room_status === "occupied"
                                ? "bg-danger"
                                : room?.room_status === "available"
                                ? "bg-success"
                                : "bg-secondary"
                            }`}
                          >
                            {room?.room_status}
                          </span>
                        </p>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Select New Room Type
                        </label>
                        <select
                          className="form-select"
                          value={reassignments[room.id]?.selectedRoomType || ""}
                          onChange={(e) =>
                            handleRoomTypeChange(
                              room?.id,
                              room?.room.id,
                              e.target.value
                            )
                          }
                        >
                          <option value="">Choose...</option>
                          {getUniqueRoomTypes().map((type) => (
                            <option key={type} value={type?.room_type}>
                              {type?.room_type}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Select New Room Number
                        </label>
                        <select
                          className="form-select"
                          value={
                            reassignments[room.id]?.selectedRoomNumber || ""
                          }
                          onChange={(e) =>
                            handleRoomNumberChange(room.id, e.target.value)
                          }
                          disabled={!reassignments[room.id]?.selectedRoomType}
                        >
                          <option value="">Choose...</option>
                          {(
                            getRoomNumbersForType(
                              reassignments[room.id]?.selectedRoomType
                            ) || []
                          ).map((roomOpt) => (
                            <option key={roomOpt.id} value={roomOpt.id}>
                              Room {roomOpt.room_number}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Reason for Reassignment *
                  </label>
                  <select
                    className="form-select"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    required
                  >
                    <option value="">Select reason...</option>
                    <option value="maintenance">Room Maintenance</option>
                    <option value="upgrade">Upgrade</option>
                    <option value="guest_request">Guest Request</option>
                    <option value="overbooking">Overbooking</option>
                    <option value="noise_complaint">Noise Complaint</option>
                    <option value="facility_issue">Facility Issue</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Additional Notes</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Optional notes or instructions"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              <i className="bi bi-x-circle me-1"></i>Cancel
            </button>
            {hasEditAccess(permissions, "reservation") && (
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                <i className="bi bi-check-circle me-1"></i>Confirm Reassignment
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomReassignmentModal;
